import React from 'react';

import { bemBlock } from '../../../modules/bem';
import { InputSelect } from '../../input-select/InputSelect';
import { LayoutRow } from '../../layout-row/LayoutRow';

import { ActionsMenuAsChildItem } from './ActionsMenuAsChildItem';
import { ActionsMenuSlotItem } from './ActionsMenuSlotItem';

import './ActionsMenuLabelSelectRow.less';

const block = bemBlock('n-actions-menu-label-select-row');

type ActionsMenuLabelSelectRowProps<TValue extends string> = {
  label: React.ReactNode;
  value: TValue;
  disabled?: boolean;
  'data-role'?: string;
  items: React.ReactNode;
  afterSelect?: React.ReactNode;
  valueComponent?: React.ReactNode;
  onValueChange: (value: TValue) => void;
  size?: React.ComponentProps<typeof InputSelect.Trigger>['variant'];
};

let counter = 0;

export const ActionsMenuLabelSelectRow = <TValue extends string>({
  label,
  value,
  items,
  disabled,
  afterSelect,
  onValueChange,
  size = 'small',
  'data-role': dataRole,
  valueComponent,
}: ActionsMenuLabelSelectRowProps<TValue>) => {
  const [c] = React.useState(() => counter++);

  const id = `actions-menu-label-select-${c}`;

  return (
    <ActionsMenuSlotItem data-role={dataRole}>
      <LayoutRow justifyContent="space-between" alignItems="center" spacedChildren="xs">
        {React.cloneElement(label as React.ReactElement, { id })}
        <InputSelect
          value={value}
          disabled={disabled}
          onValueChange={(nextValue) => onValueChange(nextValue as TValue)}
        >
          <ActionsMenuAsChildItem>
            <InputSelect.Trigger
              variant={size}
              data-value={value}
              aria-labelledby={id}
              className={block('trigger')}
            >
              {valueComponent ? (
                <InputSelect.Value asChild>{valueComponent}</InputSelect.Value>
              ) : (
                <InputSelect.Value />
              )}
            </InputSelect.Trigger>
          </ActionsMenuAsChildItem>
          <InputSelect.Content data-role="select-options">{items}</InputSelect.Content>
        </InputSelect>
        {afterSelect}
      </LayoutRow>
    </ActionsMenuSlotItem>
  );
};
